import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';
import { QuotesDataProvider } from '@services/quote/quotes-data-service/quotes.data.service';

@Component({
	selector: 'modal-make-invoice',
	template: require('./modal-make-invoice.html'),
	styles: [require('./modal-make-invoice.scss')]
})
export class ModalMakeInvoiceComponent {
	@Input('jobId') jobId: number;
	@Input('quoteId') quoteId: number;
	@Output('updateBtnActions')
	updateBtnActions: EventEmitter<number> = new EventEmitter<number>();
	disableButtons = false;

	constructor(
		private quotesDataService: QuotesDataProvider,
		private messageService: MessageService
	) {}

	generateInvoice() {
		this.disableButtons = true;
		this.quotesDataService
			.generateInvoiceFromQuote(this.jobId, this.quoteId)
			.finally(() => (this.disableButtons = false))
			.subscribe(
				data => this.successGenerateInvoice(data),
				error =>
					this.messageService.showErrorFromBackend(
						'Oops!',
						error.error.errorMessage
					)
			);
	}

	successGenerateInvoice(res) {
		this.messageService.showToaster('s_0', 'editQuote');
		$('#generateInvoiceModal').modal('hide');
		this.updateBtnActions.emit(res.data.id);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/quote/modals/modal-make-invoice/modal-make-invoice.ts